import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectChildrenPortfo: "[selectChildrenPortfo] Action",
	selectChildrenPortfoLoad: "[selectChildrenPortfoLoad] Action",
	selectChildrenPortfoAsync: "[selectChildrenPortfoAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const select_children_portfo_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectChildrenPortfo:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectChildrenPortfoLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.selectChildrenPortfoLoad, payload: payload });
	let config = {
		url: "select_request",
	};

	let data = {
		table: "accounting",
		method_type: "select_children_portfo",
		data: payload?.data ? payload?.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectChildrenPortfo,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({ type: actionTypes.selectChildrenPortfoLoad, payload: false });
	}
}

export function* selectChildrenPortfo() {
	yield takeEvery(actionTypes.selectChildrenPortfoAsync, handleWorker);
}
